export default {
  title: 'Operations',
  createNewLot: 'Create new lot',
  addDeviceType: 'Add device type',
  createSku: 'Create SKU',
  addDeviceTypeSuccess: 'Adding device type success',
};
